module.exports = __webpack_public_path__ + "static/media/expand-button16.28494d7c.webp";